// Porta das rotas /vendas/*: sem isto, quem não tem o link no menu ainda
// alcançava a tela pela URL e podia abrir uma cotação para o próprio squad —
// o backend escopa por squad, mas não barra quem não é de Vendas.

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-hook';
import { podeAcessarVendas } from './vendas-acesso';

export function VendasRoute({ children }: { children: ReactNode }) {
  // Enquanto a sessão não resolveu, o squad ainda é desconhecido — redirecionar
  // aqui expulsaria quem tem acesso.
  const { user, isAdmin, loading } = useAuth();

  if (loading) return null;
  if (!podeAcessarVendas(user?.squadNome, isAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
